var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopFavorite = function SvgTopFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.846 30.92c-1.01.404-2.123-.308-2.123-1.358V5.692c0-1.226 1.473-1.914 2.479-1.157C7.934 5.838 10 6.555 12.17 6.555s4.236-.717 5.969-2.02c1.006-.757 2.478-.07 2.478 1.158v23.869c0 1.05-1.112 1.762-2.122 1.358l-6.325-2.528-6.324 2.529Z",
    fill: "#0075C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.917 24.331c6.582 0 11.917-5.336 11.917-11.918C23.834 5.83 18.5.494 11.917.494 5.336.494 0 5.83 0 12.413 0 18.995 5.336 24.33 11.917 24.33Z",
    fill: "#FFC50A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.876 9.74 1.833-3.331c.24-.436.932-.436 1.171 0l1.833 3.33 4.097.534c.536.07.75.66.363 1l-2.965 2.593.7 3.661c.091.479-.469.844-.948.618l-3.665-1.73-3.666 1.73c-.479.226-1.04-.14-.948-.618l.7-3.661-2.964-2.593c-.388-.34-.174-.93.362-1l4.097-.533Z",
    fill: "#fff"
  })));
};
export default SvgTopFavorite;